
























































































































import { Component, Vue, Watch } from "vue-property-decorator";

import AbortButton from "@/components/Button/AbortButton.vue";
import SaveButton from "@/components/Button/SaveButton.vue";
import FscSimpleCard from "@/components/Card/FscSimpleCard.vue";
import FscCard from "@/components/Card/FscCard.vue";
import { namespace } from "vuex-class";
import { mixins } from "vue-class-component";
import TabMixin from "@/mixins/TabMixin";
import CompanyMixin from "@/mixins/CompanyMixin";
import WrongQuestionTileModal from "@/views/Student/LearnStatus/WrongQuestionTileModal.vue";
import FscModal from "@/components/Modal/FscModal.vue";

const DrivingSchool = namespace("driving-school");

@Component({
  components: { FscModal, WrongQuestionTileModal, FscSimpleCard, AbortButton, SaveButton, FscCard },
})
export default class Switches extends mixins(TabMixin, CompanyMixin) {
  public name = "Switches";

  @DrivingSchool.Action("update")
  public update: any;

  @DrivingSchool.Getter("getIsLoading")
  public isLoading: any;

  @DrivingSchool.Getter("getDrivingSchoolSwitches")
  public getDrivingSchoolSwitches: any;

  @DrivingSchool.Action("findDrivingSchoolSwitches")
  public findDrivingSchoolSwitches: any;

  public drivingSchoolSwitches: any = [];

  protected feeOnLivePayPaymentFailValue = 6;
  protected feeOnLivePayPaymentFailConfirmationModalId = "confirm-livepay-payment-failed-fee-creation";
  protected acceptedToConfigure = false;
  protected settingUpBookFeeOnLivePayPaymentFail = false;

  public async mounted(): Promise<void> {
    await this.findDrivingSchoolSwitches();
    this.drivingSchoolSwitches = this.getDrivingSchoolSwitches;
    this.drivingSchoolSwitches.licenseClasses.map((lcl: any, index: number) => {
      return (lcl.originalIndex = index);
    });
  }

  public onAbort() {
    this.closeCurrentTab();
  }

  public async onSubmit(): Promise<void> {
    if (this.hasNotPermissionWrite) return;

    const data = this.drivingSchoolSwitches;
    data.livePayPaymentFailFee = this.feeOnLivePayPaymentFailValue;
    const id = "current/switches";

    if (this.acceptedToConfigure) {
      this.settingUpBookFeeOnLivePayPaymentFail = true;
    }

    await this.update({
      id: id,
      data: data,
      resource: "driving-schools",
    });

    // Make sure to reflect the change in the store
    this.drivingSchoolSwitches.bookFeeOnLivePayPaymentFailConfigured =
      this.drivingSchoolSwitches.bookFeeOnLivePayPaymentFailConfigured || this.acceptedToConfigure;
    this.settingUpBookFeeOnLivePayPaymentFail = false;
  }

  public onBookFeeOnLivePayPaymentFailChange(e: any) {
    const firstTimeTurningSwitchOn =
      this.drivingSchoolSwitches.bookFeeOnLivePayPaymentFail && !this.drivingSchoolSwitches.bookFeeOnLivePayPaymentFailConfigured;
    if (firstTimeTurningSwitchOn && !this.acceptedToConfigure) {
      this.$bvModal.show(this.feeOnLivePayPaymentFailConfirmationModalId);
    }
  }

  public onBookFeeOnLivePayPaymentFailModalFeedback(accept: boolean) {
    if (!accept) {
      this.acceptedToConfigure = false;
      this.drivingSchoolSwitches.bookFeeOnLivePayPaymentFail = false;
    } else {
      this.acceptedToConfigure = true;
    }

    this.$bvModal.hide(this.feeOnLivePayPaymentFailConfirmationModalId);
  }
}
